import { Injectable } from '@angular/core';
import { NavigationExtras, Router, UrlTree } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  pathSegments: any = [];
  isSubDomain: boolean = false;

  constructor(private router: Router) { }

  /**
   * Navigate using commands + channel pathSegments.
   */
  navigate(commands?: any[], extras?: NavigationExtras) {
    const commandsArray = Array.isArray(commands) ? commands : [];
    const fullCommands = [...this.pathSegments, ...commandsArray];
    const safeCommands = fullCommands.length > 0 ? fullCommands : ['/'];
    this.router.navigate(safeCommands, extras);
  }

  /**
   * Navigate by URL, prefixing with channel pathSegments.
   * If the URL is absolute, skip prefixing.
   */
  navigateByUrl(url: string | UrlTree, extras?: NavigationExtras) {
    if (typeof url === 'string') {
      if (url.startsWith('/')) {
        // Absolute URL: don't prefix
        return this.router.navigateByUrl(url, extras);
      } else {
        // Relative URL: prefix with channel pathSegments
        const fullUrl = '/' + [...this.pathSegments, url].join('/');
        return this.router.navigateByUrl(fullUrl, extras);
      }
    } else {
      // It's a UrlTree: pass through as-is
      return this.router.navigateByUrl(url, extras);
    }
  }

  /** New: parse URL, supporting relative paths */
  parseUrl(url: string): UrlTree {
    if (url.startsWith('/')) {
      return this.router.parseUrl(url);
    } else {
      const fullUrl = '/' + [...this.pathSegments, url].join('/');
      return this.router.parseUrl(fullUrl);
    }
  }

  openInNewTab(path: string, skipCurrentPath: boolean = false) {
    let newPath: string;

    if (skipCurrentPath) {
      // Ignore current path — just open new path from root
      newPath = '/' + path;
    } else {
      // Default behavior: replace last segment
      const pathParts = window.location.pathname.split('/').filter(Boolean);

      if (pathParts.length === 0) {
        // Root: just use new path
        pathParts.push(path);
      } else {
        // Replace last segment
        pathParts[pathParts.length - 1] = path;
      }

      newPath = '/' + pathParts.join('/');
    }

    const newUrl = window.location.origin + newPath;
    window.open(newUrl, '_blank', 'noopener');
  }

  getFullUrlWithNewPath(newSegments: string[]): string {
    const url = new URL(window.location.href);
    const currentSegments = url.pathname.split('/').filter(Boolean);
    const baseSegments = currentSegments.slice(0, 2);
    url.pathname = '/' + baseSegments.concat(newSegments).join('/');
    return url.href;
  }

  navigateLanding() {
    this.router.navigateByUrl('/');
  }

  navigateBaseByUrl(url: string) {
    this.router.navigateByUrl(url);
  }

  navigateMerchantLanding() {
    let pathSegments = this.isSubDomain ? [environment.defaultChannelTag] : [environment.defaultSubTag, environment.defaultChannelTag];
    this.router.navigate(pathSegments);
  }

  updatePathSegments(pathSegments: any, isSubDomain: boolean) {
    this.pathSegments = pathSegments;
    this.isSubDomain = isSubDomain;
  }
}
